import React from "react";
import authService from "../services/AuthService";

interface Props {
  message?: string;
}

/**
 * Full-page recovery screen shown when the app init sequence stalls or
 * a non-transient error is encountered during provider load.
 * Provides Reload and Sign-out escapes so the user is never truly stuck.
 */
export default function InitStuckBanner({
  message = "Unable to load. This may be a temporary issue."
}: Props) {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white px-4">
      <div className="max-w-md w-full space-y-4">
        <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-red-700">
          <p className="font-medium">{message}</p>
          <p className="text-sm mt-1 opacity-80">
            Try reloading. If the problem continues, sign out and back in.
          </p>
        </div>
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Reload
          </button>
          <button
            onClick={() => authService.logout()}
            className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
